import React from 'react';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import { BLACK_ICON } from 'utilities/colors';

export const BannerSnackbarActionCloseButton = ({ snackbarKey }) => {
  const { closeSnackbar } = useSnackbar();

  const handleCloseClick = () => closeSnackbar(snackbarKey);

  return (
    <Button
      style={{ color: BLACK_ICON }}
      onClick={handleCloseClick}
      size="small"
    >
      Close
    </Button>
  );
};
